export const filterConfig = [{
  id: 'search',
  label: 'Buscar',
  type: 'text',
  placeholder: 'Buscar por título ou descrição...'
}, {
  id: 'numeroCarga',
  label: 'Número da Carga',
  type: 'text',
  placeholder: 'Filtrar por número da carga...'
},{
  id: 'numeroContainer',
  label: 'Número do Container',
  type: 'text',
  placeholder: 'Filtrar por container...'
}, {
  id: 'numeroNota',
  label: 'Número da Nota',
  type: 'text',
  placeholder: 'Filtrar por número da nota...'
}, {
  id: 'dataInicio',
  label: 'Data Início',
  type: 'date'
}, {
  id: 'dataFim',
  label: 'Data Fim',
  type: 'date'
}];
